import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { AppMaterialModule } from 'src/app/app-material.module';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { CompanyDetailsComponent } from './components/company-details/company-details.component';
import { CompanyPartnersComponent } from './components/company-partners/company-partners.component';
import { CompanyAccountsComponent } from './components/company-accounts/company-accounts.component';
import { AddBankAccountComponent } from './modals/add-bank-account/add-bank-account.component';

const routes: Routes = [{ path: '', component: AccountComponent }];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxMaskModule.forChild(),
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    AppMaterialModule,
    SharedComponentsModule,
  ],
  declarations: [
    AccountComponent,
    CompanyDetailsComponent,
    CompanyPartnersComponent,
    CompanyAccountsComponent,
    AddBankAccountComponent,
  ],
})
export class AccountModule {}
